var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5713_15168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.829102 8.9113C0.829102 7.43689 1.99274 6.23055 3.41496 6.23055H7.29374L9.8796 3.5498H17.6372L20.223 6.23055H24.1018C24.7876 6.23055 25.4453 6.51298 25.9303 7.01572C26.4152 7.51846 26.6877 8.20032 26.6877 8.9113V22.315C26.6877 23.026 26.4152 23.7079 25.9303 24.2106C25.4453 24.7133 24.7876 24.9958 24.1018 24.9958H3.41496C2.72915 24.9958 2.07142 24.7133 1.58648 24.2106C1.10154 23.7079 0.829102 23.026 0.829102 22.315V8.9113ZM13.7584 22.315C15.4729 22.315 17.1172 21.6089 18.3296 20.3521C19.5419 19.0952 20.223 17.3906 20.223 15.6132C20.223 13.8357 19.5419 12.1311 18.3296 10.8742C17.1172 9.61738 15.4729 8.9113 13.7584 8.9113C12.0438 8.9113 10.3995 9.61738 9.18719 10.8742C7.97483 12.1311 7.29374 13.8357 7.29374 15.6132C7.29374 17.3906 7.97483 19.0952 9.18719 20.3521C10.3995 21.6089 12.0438 22.315 13.7584 22.315ZM13.7584 19.6343C13.249 19.6343 12.7446 19.5303 12.274 19.3282C11.8034 19.1261 11.3758 18.8299 11.0157 18.4565C10.6555 18.0831 10.3698 17.6398 10.1749 17.152C9.97992 16.6641 9.8796 16.1412 9.8796 15.6132C9.8796 15.0851 9.97992 14.5622 10.1749 14.0743C10.3698 13.5865 10.6555 13.1432 11.0157 12.7698C11.3758 12.3964 11.8034 12.1002 12.274 11.8981C12.7446 11.696 13.249 11.592 13.7584 11.592C14.7871 11.592 15.7737 12.0157 16.5011 12.7698C17.2285 13.5239 17.6372 14.5467 17.6372 15.6132C17.6372 16.6796 17.2285 17.7024 16.5011 18.4565C15.7737 19.2106 14.7871 19.6343 13.7584 19.6343Z",
    fill: "#2C2C2C",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5713_15168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8586,
    height: 26.8075,
    fill: "white",
    transform: "translate(0.829102 0.869141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.4f68231ce35aca557ab9b2cfd851facc.svg";
export { ForwardRef as ReactComponent };